"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;

var tslib_1 = require("tslib");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icon_1 = require("@hopin-team/ui-icon");

var react_1 = tslib_1.__importStar(require("react"));

var root_1 = require("./styled/root");

var Toast = function Toast(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      children = _a.children,
      className = _a.className,
      colorPattern = _a.colorPattern,
      icon = _a.icon,
      iconColor = _a.iconColor,
      isInverse = _a.isInverse,
      onClose = _a.onClose,
      _b = _a.role,
      role = _b === void 0 ? 'status' : _b,
      withCloseButton = _a.withCloseButton,
      _c = _a.closeButtonTitle,
      closeButtonTitle = _c === void 0 ? 'Close toast' : _c;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Toast',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var count = react_1.Children.count(children) - 1;
  var a11yProps = {
    role: role
  };

  if (role === 'alert') {
    a11yProps['aria-live'] = 'assertive';
  } else {
    a11yProps['aria-live'] = 'polite';
  }

  return react_1.default.createElement(root_1.Root, tslib_1.__assign({
    className: rootClasses,
    "data-testid": testID,
    cornerRadius: "lg",
    level: "high",
    gridGap: "2",
    pl: 2,
    gridTemplateColumns: "".concat(icon ? '1.5rem' : '', " 1fr ").concat(count ? "repeat(".concat(count, ", auto)") : '', " ").concat(withCloseButton ? 'auto' : ''),
    colorPattern: colorPattern,
    isInverse: isInverse
  }, a11yProps), icon && react_1.default.createElement(ui_icon_1.Icon, {
    name: icon,
    "aria-hidden": true,
    color: iconColor
  }), children, withCloseButton && react_1.default.createElement(ui_butticon_1.Butticon, {
    icon: "close",
    onClick: onClose,
    title: closeButtonTitle,
    pattern: isInverse ? undefined : 'inverse',
    isGhost: true,
    mr: 2
  }));
};

var ToastWithSpace = (0, ui_helper_with_space_1.withSpace)(Toast);
exports.Toast = ToastWithSpace;